import { Query, User } from "@/app/graphql/codegen";
import { useQuery } from "@apollo/client";
import { FETCH_USER_PROFILE } from "@company/graphql/queries/fetchUserProfile";

export const useUserProfile = () => {
    const { data, loading } = useQuery<Pick<Query, "userProfile">, User>(FETCH_USER_PROFILE);

    return {
        user: data?.userProfile,
        loading,
    };
};
